export { getNodeDescription } from './getNodeDescription'
